exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item{\n    background-color: #d33939;\n    border-bottom: 2px;\n    border-color: blanchedalmond;\n    box-shadow: 3px 6px 11px -1px rgba(0,0,0,0.75);\n    width: 100%;\n    min-width: 200px;\n    \n}\n\n.list-item-text{\n    color:white;\n}\n\n.list-item:hover{\n    background-color:#ee0c0c;\n    cursor: pointer;\n}\n\n.dashboard-logo{\n    width: 125px;\n    height: 35px;\n}\n\n.logo-container{\n    margin-left: 10px;\n}\n\n\n.profile-icon{\n    margin-right: -20px;\n \n}\n\n.smallNote{\n    font-size: 8px;\n}\n\n", ""]);

// exports
